import { Restaurant } from '../models/Food/Restaurant';
import * as React from 'react';
import { ReactElement } from 'react';
import i18next from 'i18next';
import discussionTypes from './discussionTypes';
import { BaggageInfos } from '../models/Flight/Flight';
var countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/ru.json'));

export function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function units(num: number, cases: string[]) {
    num = Math.abs(num);
    let word: string = '';
    if (num.toString().indexOf('.') > -1) {
        word = cases[1];
    } else {
        word = (
            num % 10 === 1 && num % 100 !== 11
                ? cases[0]
                : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
                    ? cases[1]
                    : cases[2]
        );
    }
    return word;
}

export function stopEvent(e: any) {
    if (e) {
        e.cancelBubble = true;
        if (e.stopPropagation) {
            e.stopPropagation();
        }
    }
}

export function peopleToStr(adults: number, children: number, infants: number) {
    const peopleArr = [];
    if (adults) {
        if (adults > 1) {
            peopleArr.push(i18next.t('adult_1', { count: adults }));
        } else {
            peopleArr.push(i18next.t('adult_0', { count: adults }));
        }
    }
    if (children || infants) {
        if (children) {
            if (children > 2) {
                if (children > 4) {
                    peopleArr.push(i18next.t('child_2', { count: children }));
                } else {
                    peopleArr.push(i18next.t('child_1', { count: children }));
                }
            } else {
                peopleArr.push(i18next.t('child_0', { count: children }));
            }
        }
        if (infants) {
            if (infants > 1) {
                peopleArr.push(i18next.t('baby_1', { count: infants }));
            } else {
                peopleArr.push(i18next.t('baby_0', { count: infants }));
            }
        }
    } else if (adults) {
        peopleArr.push(i18next.t('without_children'));
    }
    let peopleStr = peopleArr.join(', ');
    const peopleSet = !!peopleStr.trim().length;
    if (!peopleSet) {
        return '';
    }
    return peopleStr;
}

export function getAddTags(r: Restaurant, ids: number[]) {
    const dop = r.tag_groups ? r.tag_groups.find(t => t.type.toLowerCase() === i18next.t('extra')) : null;
    if (!dop) {
        return [];
    }
    return ids.map(id => {
        return dop.tags.find(t => t.id === id);
    }).filter(v => !!v);
}

export function parseTextWithLinks(text: string, linkClassName: string = ''): ReactElement<any> {
    const urlRegex = new RegExp(/^(ftp|http|https):\/\/[^ "]+$/);
    const phoneRegex = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
    const emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    return React.createElement('pre', '', text.split(new RegExp(/([ \n\t])/)).map((word: string) => {
        if (urlRegex.test(word)) {
            return React.createElement('a', {
                href: word,
                target: '_blank',
                class: linkClassName
            }, word);
        } else if (emailRegex.test(word)) {
            return React.createElement('a', {
                href: `mailto:${word}`,
                target: '_blank',
                class: linkClassName
            }, word);
        } else if (phoneRegex.test(word)) {
            return React.createElement('a', {
                href: `tel:${word}`,
                target: '_blank',
                class: linkClassName
            }, word);
        } else {
            return word;
        }
    }));
}

export async function checkUserId(userIdFromRef: string, userId: string, reauthorizate: any, getProfileInfo: any, setUserIdAction: any) {
    if (localStorage.KON_USER_ID !== userIdFromRef) {
        if (localStorage.KON_USER_ID) {
            alert(i18next.t('access_is_not_possible_incorrect_link'));
            reauthorizate();
        } else {
            while (true) {
                alert(i18next.t('access_is_not_possible_you_are_not_authorized'));
            }
        }
        return '';
    } else {
        const konUserId: string = localStorage.KON_USER_ID;
        if (!localStorage.KON_TARIFF_ID || !localStorage.phone) {
            await getProfileInfo(konUserId);
        }
        if (!userId || userId !== konUserId) {
            setUserIdAction(konUserId);
        }
        return konUserId;
    }
}

export function checkChannelId(channelId: string, setChannelIdAction: any) {
    const konChannelId = localStorage.KON_CHANNEL_ID;
    if (!channelId || channelId !== konChannelId) {
        setChannelIdAction(konChannelId);
    }
    return konChannelId;
}

export function checkTariffId(tariffId: number, setTariffIdAction: any) {
    const konTariffId = localStorage.KON_TARIFF_ID;
    if (!tariffId || tariffId !== konTariffId) {
        setTariffIdAction(konTariffId);
    }
    return konTariffId;
}

export async function checkAccessToken(userId: any, refreshToken: () => any, authString: any) {
    const auth: any = JSON.parse(authString);
    let expireInMS: number = (auth.created_at + auth.expires_in - Math.floor(Date.now() / 1000)) * 1000;
    if (expireInMS <= 0) {
        await refreshToken();
    }
}

export function getDiscussionKeyFromId(discussionTypeId: number) {
    if (discussionTypeId === discussionTypes.accounting.id) {
        return  discussionTypes.accounting.key;
    } else if (discussionTypeId === discussionTypes.legal.id) {
        return  discussionTypes.legal.key;
    } else if (discussionTypeId === discussionTypes.medicine.id) {
        return  discussionTypes.medicine.key;
    } else if (discussionTypeId === discussionTypes.psychology.id) {
        return  discussionTypes.psychology.key;
    } else if (discussionTypeId === discussionTypes.stylist.id) {
        return  discussionTypes.stylist.key;
    } else if (discussionTypeId === discussionTypes.children.id) {
        return  discussionTypes.children.key;
    } else {
        return '';
    }
}

export function generateHash() {
    const randArr = crypto.getRandomValues(new Uint32Array(2));
    const hash = randArr![0].toString() + randArr![1].toString();
    /*const hash = hashContent + moment().format('DDMMYYYYHHmmsss');
    console.log(hash);*/
    return hash;
}

export function getCountryNameFromCode(code: string) {
    if (code === 'RU') {
        return 'Россия';
    }
    return countries.getName(code, 'ru', {select: 'official'});
}

export function getTimeStrFromMinutes(time: number, minutesLabel?: string, hoursLabel?: string, daysLabel?: string) {
    const days = Math.floor(time / 60 / 24);
    const hours = Math.floor(time % (60 * 24) / 60);
    const minutes = time % 60;
    return !minutesLabel
        ? `${hours ? `${hours}` : '00'}:${minutes ? `${minutes}` : '00'}`
        : ` ${days ? `${days}${daysLabel}` : ''} ${hours ? `${hours}${hoursLabel}` : ''} ${minutes ? `${minutes}${minutesLabel}` : ''}`;
}

export function parseBaggageInfosFlight(str: any, type: string) {
    let baggageInfos: BaggageInfos = {
        label: '',
        value: null,
        weight: null
    };
    if (str === false) {
        baggageInfos.label = i18next.t(`no_included_${type}`);
        return baggageInfos;
    } else if (str.length === 0) {
        baggageInfos.label = i18next.t(`no_info_${type}`);
        return baggageInfos;
    } else if (str === '0PC') {
        baggageInfos.label = i18next.t(`no_${type}`);
        return baggageInfos;
    } else if (Number(str)) {
        baggageInfos.weight = str;
        return baggageInfos;
    } else {
        let baggageValues = str.replace('PC', ' ').split(' ');
        if (baggageValues[0]) {
            baggageInfos.value = baggageValues[0];
        }
        if (baggageValues[1] !== 'null') {
            baggageInfos.weight = Number(baggageValues[1].replace('x', '')) ? baggageValues[1] + i18next.t('kg') : baggageValues[1].replace('x', '');
        }
        return baggageInfos;
    }
}

export function copyToClipboard(code: string) {
    let textField = document.createElement('textarea');
    textField.innerText = code;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
}



// WEBPACK FOOTER //
// ./src/lib/utils.ts